export default {
  namespaced: true,

  state: {
    loading: false,
    loadingText: 'Cargando...'
  },

  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload.value
      state.loadingText = payload.text || 'Cargando...'
    }
  }
}